<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box">
				<span>客户类别：</span>
                <el-select v-model="customercategoryid" class="name-input" size='mini'>
                    <el-option :value="item.ccid" :label="item.ccname" :key="item.ccid" v-for="item in categoryList"></el-option>
                </el-select>
			</div>
            <div class="input-box">
				<span>客户名称：</span>
				<el-input
					v-model="name"
					placeholder="请输入客户名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>线路：</span>
				<el-input
					v-model="lineName"
					placeholder="请输入线路名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>客户状态：</span>
                <el-select v-model="disabledflag" class="name-input" size='mini'>
                    <el-option :value="2" label="全部"></el-option>
                    <el-option :value="0" label="启用"></el-option>
                    <el-option :value="1" label="停用"></el-option>
                </el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
					@click="search">查询</el-button>
			</div>
			<div class="input-box-btn">
				<el-button
					class="search-btn"
					size="mini"
					plain
					@click="clearClick">清空</el-button>
			</div>
		</div>
		<div class="table-container">
			<div class="table-box">
				<div class="select-title">请选择客户</div>
				<el-table
					:stripe='true'
					ref='multipleTable'
					class="grid-content"
					:data="tableData"
					size='mini'
					:height="tableHeight"
					border
					@select="handleSelectionChange"
					@select-all="handleSelectionChange">
					<el-table-column
					fixed='left'
					type="selection"
					align="center"
					width="55">
					</el-table-column>
						<el-table-column
							label-class-name = "column-index"
							label="序号"
							type="index"
							width="70"
							align="center">
						</el-table-column>
						<el-table-column
							prop="customerCategoryName"
							label="客户类别"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="customerName"
							label="客户名称"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="linename"
							label="线路"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="disabledflag"
							label="客户状态"
							align="center"
							min-width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.disabledflag === true">停用</span>
								<span v-else>启用</span>
							</template>
						</el-table-column>
				</el-table>
				<div class="page-box">
					<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="page.number"
					:page-sizes="[20, 40, 60, 100, 300]"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
				</div>
			</div>
			<div style="margin-left: 20px;" class="table-box">
				<div class="select-title">已选择客户：{{this.ids.length}}人</div>
				<el-table
					:stripe='true'
					ref='multipleTable1'
					class="grid-content"
					:data="ids"
					size='mini'
					:height="tableHeight"
					border
					@select="handleSelectionChange1"
					@select-all="handleSelectionChange1">
					<el-table-column
					fixed='left'
					type="selection"
					align="center"
					width="55">
					</el-table-column>
						<el-table-column
							label-class-name = "column-index"
							label="序号"
							type="index"
							width="70"
							align="center">
						</el-table-column>
						<el-table-column
							prop="customerCategoryName"
							label="客户类别"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="customerName"
							label="客户名称"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="linename"
							label="线路"
							align="center"
							min-width="150">
						</el-table-column>
						<el-table-column
							prop="disabledflag"
							label="客户状态"
							align="center"
							min-width="120">
							<template slot-scope="scope">
								<span v-if="scope.row.disabledflag === true">停用</span>
								<span v-else>启用</span>
							</template>
						</el-table-column>
				</el-table>
			</div>
		</div>
         <div class="binding-foot">
            <el-button class="btn" plain type="primary" size='small' @click="cancelClick">取消</el-button>
			<el-button class="btn" plain type="primary"  size='small' @click="saveScheme">确认添加</el-button>
        </div>
	</div>
</template>
<script>
const tableHeight1 = 'calc(100% - 80px)'
export default {
	name: 'copyModal',
	props: {
		copyModal: Boolean,
		isRelationship: Boolean,
		ppIds: Array,
		syscode: String,
		customerName: String,
		syscodeId: String,
		customerId: String
	},
	data () {
		return {
			name: '',
			disabledflag: 2,
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			customerids: [],
			tableHeight: tableHeight1,
			customercategoryid: -1,
			categoryList: [],
			allObj: [{ ccname: '全部', ccid: -1 }],
			lineName: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'customerid'
			})
		}
	},
	watch: {
		copyModal: {
			handler (val) {
				if (val) {
					this.tableReload()
				}
			},
			immediate: true
		}
	},
	created () {
		this.getTreeData()
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.ids, this.$refs.multipleTable1)
			})
		},
		handleSelectionChange1 (data) {
			this.tableSelectUtils.selectToggle(this.ids, data)
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
			})
		},
		getTreeData () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.categoryList = this.allObj.concat(res.data.childNode)
				} else {
					this.$message.error(res.msg)
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		cancelClick () {
			this.$emit('cancel', false)
		},
		saveScheme () {
			if (this.ids.length === 0) {
				this.$message.error('请选择客户')
				return false
			}
			this.$confirm('同步到其他客户是将其他客户的订货方案与该客户的订货方案完全保持一致，确定继续操作？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: '',
				closeOnClickModal: false
			}).then(() => {
				this.saveSchemeSynchroClick()
			}).catch(() => {
			})
		},
		saveSchemeSynchroClick () {
			let params = {}
			let url = ''
			let customerIds = []
			let logArr = []
			this.ids.forEach(item => {
				customerIds.push(item.customerid)
				logArr.push(item.customerName)
			})
			url = `${this.$fxBaseApi.urlQIVShop}/customer/synchronizationOrderGoodsDate`
			params = {
				customerId: this.customerId,
				customerIds: customerIds
			}
			let logUrl = window.location.href.split('?')[0]
			logUrl = logUrl.replace(window.location.origin, '').substring(1)
			let msg = `将”客户：${this.customerName}”设置的“全部订货方案”同步到客户：` + logArr.join(',')
			params.logMessage = {
				message: msg,
				referer: logUrl
			}
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableSelectUtils.clear()
					this.tableReload()
					this.$message.success('同步成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clearClick () {
			this.customercategoryid = -1
			this.disabledflag = 2
			this.name = ''
			this.lineName = ''
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		search () {
			// this.tableSelectUtils.clear()
			this.page = {
				number: 1,
				size: 20
			}
			this.tableReload()
		},
		tableReload () {
			let params = {
				name: this.name,
				delSyscode: this.syscode,
				disabledflag: this.disabledflag,
				page: this.page.number,
				size: this.page.size,
				customercategoryid: this.customercategoryid,
				keyword: this.lineName
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getCustomerOfCopy`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.data
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.multipleTable)
					})
					this.total = +res.data.count
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :100%;
	flex-direction: column;
    height :600px;
    overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			// margin-left :10px;
			width :220px;
			margin-bottom:10px
			.name-input {
				width: 140px;
				margin-right: 10px;
			}
			.select-box{
				width:100px;
				margin-right:10px;
			}
		}
	}
	.table-container{
		display: flex;
		box-sizing: border-box
		flex-direction: row
		height:calc(100% - 110px);
	}
	.select-title{
		line-height: 30px;
		text-align: left
	}
    .table-box{
		width: calc(50% - 10px)
        padding-bottom :10px;
        height: 100%
		.page-box{
			margin-top:10px
			text-align :center
		}
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        margin-bottom :10px;
        width :100%
        .btn{
            width :35%;
			margin-left:30px;
        }
    }
}

</style>
<style lang="stylus">
.cell{
	padding: 0 !important
}
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
